module.exports = __webpack_public_path__ + "img/calendario-lg.dd93a9fe.png";